import { render, staticRenderFns } from "./PromocodeStats.vue?vue&type=template&id=e1ea4020&scoped=true"
import script from "./PromocodeStats.vue?vue&type=script&lang=js"
export * from "./PromocodeStats.vue?vue&type=script&lang=js"
import style0 from "./PromocodeStats.vue?vue&type=style&index=0&id=e1ea4020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ea4020",
  null
  
)

export default component.exports